<template>
  <a-col :span="8" class="card" :class="{ disabled }">
    <a-row class="avatar">
      <div class="avatar__wrapper" @click.stop="handleShowForm()">
        <img src="@/assets/icons/IconPlus.svg" alt="" />
      </div>
    </a-row>
    <a-row class="label"> Добавить сотрудника </a-row>
  </a-col>
  <c-drawer v-model:open="isShowForm" destroyOnClose>
    <component
      :is="TeamMemberForm"
      @close="handleCloseForm"
      @update="updateExecutors"
    />
  </c-drawer>
</template>

<script setup>
  import CDrawer from '@/components/UI/CDrawer.vue';
  import TeamMemberForm from './TeamMemberForm.vue';
  import { ref } from 'vue';

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['close', 'update']);

  const updateExecutors = () => {
    emit('update');
  };

  const isShowForm = ref(false);

  const handleShowForm = () => {
    if (!props.disabled) {
      isShowForm.value = true;
    }
  };

  const handleCloseForm = () => {
    isShowForm.value = false;
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  * {
    font-family: 'Nunito Sans', sans-serif;
  }

  .card {
    align-items: center;
    background-color: $color-bg-primary-white;
    border: 2px dashed $color-input;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 9px;
    max-height: 389px;
    max-width: 325px;
    user-select: none;
    width: 325px;
    height: 389px;

    .avatar {
      &__wrapper {
        align-items: center;
        background-color: $color-bg-primary-white;
        border: 2px dashed $color-input;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        position: relative;
        height: 80px;
        width: 80px;

        img {
          filter: invert(82%) sepia(2%) saturate(4563%) hue-rotate(197deg)
            brightness(89%) contrast(93%);
          margin: auto;
          height: 21px;
          width: 21px;
        }

        .skeleton {
          width: auto;
        }
      }
    }

    .label {
      color: $color-bg-status-new;
      font-weight: 400;
      font-size: 14px;
      line-height: 19.1px;
      padding: 20px 30px;
    }

    &.disabled {
      cursor: default;
    }
  }
</style>
